import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, trim } from 'ramda'
import strings from 'utils/strings'
import { Icon } from 'components/patterns/Icon/Icon'
import { StyledSaveNoteButton, StyledTextArea } from './AddNote.style'

const AddNote = ({ onSubmit, onChange, defaultNote = '' }) => {
  const [newNote, setNewNote] = useState(defaultNote)
  const [spinning, setSpinning] = useState(false)

  const handlePressEnter = useCallback(async () => {
    const trimmedNote = trim(newNote)
    if (isEmpty(trimmedNote)) return
    setSpinning(true)

    await onSubmit(trimmedNote)
    setSpinning(false)
    setNewNote('')
    onChange('')
  }, [newNote, onSubmit, onChange])

  const isSaveDisabled = !newNote.length

  const handleOnChange = (event) => {
    const { value } = event.target
    setNewNote(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <>
      <StyledTextArea
        value={newNote}
        onChange={handleOnChange}
        autosize={{ minRows: 1, maxRows: 6 }}
        placeholder={strings.add_note_placeholder}
        maxLength={1000}
      />
      <StyledSaveNoteButton
        onClick={handlePressEnter}
        disabled={isSaveDisabled}
        loading={spinning}
      >
        {!spinning && (
          <Icon
            icon="save"
            size={14}
            fill={
              isSaveDisabled ? 'rgba(7, 7, 15, 0.4)' : 'rgba(255, 255, 255, 1)'
            }
          />
        )}
        {strings.save_note}
      </StyledSaveNoteButton>
    </>
  )
}

AddNote.defaultProps = {
  onSubmit: () => {},
  onChange: () => {},
  defaultNote: '',
}

AddNote.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  defaultNote: PropTypes.string,
}

export default AddNote
